import logger from "~/helpers/logger";

const registeredFlushes = new Set<() => void>();

const flushOneIgnoringFailure = (flush: () => void): void => {
	try {
		flush();
	} catch (err) {
		logger.error("dockLayoutHideFlushRegistry: a registered flush threw and was skipped", err);
	}
};

const flushAll = (): void => {
	registeredFlushes.forEach(flushOneIgnoringFailure);
};

const register = (flush: () => void): (() => void) => {
	registeredFlushes.add(flush);
	return () => registeredFlushes.delete(flush);
};

const dockLayoutHideFlushRegistry = { flushAll, register };

export default dockLayoutHideFlushRegistry;
